import { useState } from "react";
import { useLogin } from "@/features/auth/hooks/useLogin";
import { Button, Flex, TextField, Text, Box } from "@radix-ui/themes";
import Alert from "@/components/Alert/Alert";

export const LoginForm = () => {
  const { handleLogin, loading, error } = useLogin();

  const [loginValues, setLoginValues] = useState<{
    email: string;
    password: string;
  }>({
    email: "",
    password: "",
  });

  const setNewLoginValue = (targetName: string, value: string) => {
    return setLoginValues((prev: { email: string; password: string }) => ({
      ...prev,
      [targetName]: value,
    }));
  };

  return (
    <Box>
      <Flex direction="column" gap="4">
        {/* Email */}
        <Flex direction="column" gap="1">
          <Text as="label" size="2">
            Email
          </Text>
          <TextField.Root
            size="3"
            type="text"
            value={loginValues.email}
            onChange={(e) => {
              setNewLoginValue("email", e.target.value);
            }}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                if (loginValues.password) {
                  handleLogin(loginValues.email, loginValues.password);
                }
              }
            }}
          />
        </Flex>
        {/* Password */}
        <Flex direction="column" gap="1">
          <Flex justify="between" align="end">
            <Text as="label" size="2">
              Password
            </Text>
            {/* <Text
                size="1"
                color="gray"
                onClick={() => navigate("/forgot-password")}
              >
                {i18next.t("auth.login.forgot_password")}
              </Text> */}
          </Flex>
          <TextField.Root
            size="3"
            type="password"
            value={loginValues.password}
            onChange={(e) => {
              setNewLoginValue("password", e.target.value);
            }}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                if (loginValues.password) {
                  handleLogin(loginValues.email, loginValues.password);
                }
              }
            }}
          />
        </Flex>
        {error && <Alert>{error.message}</Alert>}
        <Button
          size="3"
          disabled={!loginValues.email || !loginValues.password || loading}
          onClick={() => {
            if (!loading) {
              handleLogin(loginValues.email, loginValues.password);
            }
          }}
        >
          {loading ? "Signing you in .." : "Sign In"}
        </Button>
      </Flex>
    </Box>
  );
};
